export const TrafficTypes = ['Gaming', 'Forex', 'Ecommerce'];
export const PaymentMethods = ['CARD', 'MOBILE_MONEY', 'CRYPTO'];

export const ServiceTypes = [
  'mpgs',
  'vcs',
  'mpesa',
  'mtn',
  'airtel',
  'flutterwave',
  'cellulant',
  'relworx',
  'savannah',
  'mauzo',
  'chakra',
  'pivot',
  'ipay',
  'sapamacash',
  'paytota',
];
export const Providers = [
  'CARD_USD',
  'CARD_EUR',
  'MTN_UGX',
  'AIRTEL_UGX',
  'MPESA_KES',
];

export const Currencies = [
  'USD',
  'EUR',
  'UGX',
  'KES',
];

export const TransactionTypesArray = [
  'COLLECTION',
  'SETTLEMENT',
  'REFUND',
  'CHARGEBACK',
  'DISBURSEMENT',
  'WITHDRAWAL',
  'DEPOSIT',
];

export const TransactionTypes = {
  COLLECTION: 'COLLECTION',
  SETTLEMENT: 'SETTLEMENT',
  REFUND: 'REFUND',
  CHARGEBACK: 'CHARGEBACK',
  DISBURSEMENT: 'DISBURSEMENT',
  WITHDRAWAL: 'WITHDRAWAL',
  DEPOSIT: 'DEPOSIT',
};

export const TransactionStatuses = {
  PENDING: 'PENDING',
  CONFIRMING: 'CONFIRMING',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
};

export const Environments = {
  PRODUCTION: 'production',
  SANDBOX: 'sandbox',
  STAGING: 'staging',
  LOCALHOST: 'localhost',
  DEVELOPMENT: 'development',
  TEST: 'test',
};

export const GITLAB_PROJECT_IDS = {
  DATA_SERVICE: '24937964',
};

export const maskApiKey = (apiKey, firstLength = 6, lastLength = 6) => {
  const lastCharacters = apiKey.substr(Math.abs(lastLength) * -1);
  const firstCharacters = apiKey.substr(0, Math.abs(firstLength));
  return `${firstCharacters}*******${lastCharacters}`;
};
